  /*============Account Address Audit Controller
   ================================*/
  angular
  .module('vppApp')
  .controller('accountAuditController', accountAuditController);

  accountAuditController.$inject = ['$scope', '$rootScope', '$state', 'apiFactory', '$timeout', 'AuthenticationService', 'CustomerService'];

  function accountAuditController($scope, $rootScope, $state, apiFactory, $timeout, AuthenticationService, CustomerService) {

    $scope.authError = "";

    CustomerService.loadedCallback(function(){

      if ($rootScope.accountAudit === true) {

        /* wait for it to load */
        var isAuthenticated = AuthenticationService.isAuthenticated();
        if (isAuthenticated) {
          var cd = CustomerService.getCustomerData();
          $scope.firstName = cd.customer.firstName;
          $scope.lastName = cd.customer.lastName;
          $scope.address1 = cd.customer.address1;
          $scope.address2 = cd.customer.address2;
          $scope.city = cd.customer.city;
          $scope.state = cd.customer.state;
          $scope.zipCode = cd.customer.zipCode;
          $scope.country = cd.customer.country;
        }
      } else {
        $state.go('view-auth');
      }

    });
    /* send out the address correct to API */
    $scope.addressCurrent = function () {
      var accountId = AuthenticationService.getAuthenticatedID();
      var status = {
        "auditAction": "addresscurrent-yes"
      };
      apiFactory.auditAction(accountId, status)
      .then(function () {
        delete $rootScope.accountAudit;
        $scope.updateUserInformation();
      }, function (error) {
        $scope.updateUserInformation();
      });
    };

    /* send out the address not correct to API */
    $scope.addressNotCurrent = function () {
      var accountId = AuthenticationService.getAuthenticatedID();
      var status = {
        "auditAction": "addresscurrent-no"
      };
      apiFactory.auditAction(accountId, status)
      .then(function successAuditAction(response) {
        $state.go('address-edit');
      }, function errorCallback(response) {
        //console.log(response);
        $scope.serverError = response.data.errors;
        if (response.data.errors[0].errorCode === '9081') {
          $scope.editTooSoon = true;
          $scope.authError = "For security reasons, you are only allowed to update your address once in 30 days. Our records indicate that your last address change was within the last 30 days. If you still want to update, please contact customer service at 1-800-235-4646.";
          status = {
            "auditAction": "editinterval-toosoon"
          };
          apiFactory.auditAction(accountId, status);
        }
      });

    };

    /* used to repopulate the 'view-auth' view once you verify address is accurate.*/
    $scope.updateUserInformation = function () {
      var accountId = AuthenticationService.getAuthenticatedID();
      apiFactory.getCustomer(accountId)
      .then(function successGetCustomer(response) {
        delete $rootScope.accountAudit;

        CustomerService.setCustomer(response);
        $state.go('view-auth');

      }, function errorCallback(response) {
        $scope.serverError = response.data.errors;
      });
    };

    $scope.goBackToAudit = function () {
      $scope.updateUserInformation();
    };

  };